import { BackgroundColors, PrimaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';
import { makeStyles } from '@material-ui/core/styles';

const useNotificationCardStyles = makeStyles(
  (muiTheme) => ({
    root: {
      borderRadius: 0,
      backgroundColor: BackgroundColors.dark,
      color: TextColors.light,
      '&:hover': {
        backgroundColor: PrimaryColors.light,
      },
      '& .content': {
        padding: muiTheme.spacing(2, 4),
      },
    },
    title: {
      textAlign: 'left',
      fontSize: '14px',
      marginBottom: muiTheme.spacing(1.5),
    },
    category: {
      textAlign: 'left',
      color: hexToRGBA(TextColors.light, TextOpacities.dark2),
      textTransform: 'uppercase',
      fontSize: '10px',
      marginBottom: muiTheme.spacing(1.5),
    },
    description: {
      textAlign: 'left',
      fontSize: '14px',
      marginBottom: muiTheme.spacing(1.5),
    },
    time: {
      textAlign: 'left',
      fontSize: '12px',
      color: TextColors.light,
    },
    imageContainer: {
      marginBottom: muiTheme.spacing(1.5),
    },
    unreadBadge: {
      position: 'absolute',
      width: '6px',
      height: '6px',
      borderRadius: '50%',
      backgroundColor: '#12D08C',
      left: 16,
      top: 21,
    },
    buttonBase: {
      width: '100%',
      display: 'block',
    },
  }),
  { name: 'NotificationCard' },
);

export default useNotificationCardStyles;
